<!-- Content Area -->
<div class="p-8">
    <div class="flex justify-between items-center mb-6">
        <h1 class="text-xl lg:text-3xl font-bold text-gray-900">Partnership List</h1>
    </div>

    <!-- Table -->
    <div class="bg-white rounded-lg shadow-sm mb-6">
        <div class="overflow-x-auto">
            <table class="w-full">
                <thead>
                    <tr class="border-b border-gray-200">
                        <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                            No
                        </th>
                        <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                            Name Event
                        </th>
                        <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                            Tanggal Event
                        </th>
                        <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                            Lokasi Event
                        </th>
                        <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                            Total Partisipant
                        </th>
                        <th class="text-left py-4 px-6 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                            Created At
                        </th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                    <tr
                        *ngFor="let item of partnerships; let i = index"
                        class="hover:bg-gray-50 transition-colors"
                    >
                        <td class="py-4 px-6 text-sm text-gray-900">
                            {{ (pagination.current_page - 1) * pagination.per_page + i + 1 }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-900">
                            {{ item.event_name || '-' }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ item.event_date || '-' }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ item.location || '-' }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ item.qty_participant || '-' }}
                        </td>
                        <td class="py-4 px-6 text-sm text-gray-600">
                            {{ item.created_at || '-' }}
                        </td>
                    </tr>

                    <!-- Empty State -->
                    <tr *ngIf="partnerships.length === 0">
                        <td colspan="8" class="py-8 text-center text-gray-500">
                            Tidak ada data partnership
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Pagination -->
        <div class="flex items-center justify-between px-6 py-4 border-t border-gray-200">
            <button
                (click)="previousPage()"
                [disabled]="pagination.current_page === 1"
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <img
                    src="assets/visidea/icon/left.png"
                    class="w-[12px] h-[12px]"
                    alt=""
                />
                <span>Previous</span>
            </button>

            <span class="text-sm text-gray-600">
                Page {{ pagination.current_page }} of {{ pagination.last_page }}
            </span>

            <button
                (click)="nextPage()"
                [disabled]="pagination.current_page === pagination.last_page"
                class="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
                <span>Next</span>
                <img
                    src="assets/visidea/icon/right.png"
                    class="w-[12px] h-[12px]"
                    alt=""
                />
            </button>
        </div>
    </div>
</div>
